import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { TipProgramService } from '../tip-program.service';
import { MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize, map } from 'rxjs';
import { helper } from 'src/environments/helper';
import { TipProgram } from '../tip-program.interface';

@Component({
    selector: 'app-add-tip-program',
    templateUrl: './add-tip-program.component.html',
    styleUrls: ['./add-tip-program.component.scss']
})
export class AddTipProgramComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;

    form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
        observatii: new FormControl(''),
    });

    constructor(
        private dialogRef: MatDialogRef<AddTipProgramComponent>,
        private tipProgramService: TipProgramService,
        private notificationService: NotificationService,
        private authService: AuthService,
    ) {
        this.processToken();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.tipProgramService.setToken(token);
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name, observatii } = this.form.value as TipProgram;

        const newTipProgram: TipProgram = {
            name,
            observatii
        };

        this.tipProgramService
            .addTipProgram(newTipProgram)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
